// Tunable command durations and cooldowns (ms)

export const CommandDurations = {
	healBiasMs: 30000,
	healNaturalCooldownMs: 30000,
	attackBiasMs: 30000,
	attackFocusMs: 5000,
	lootBiasMs: 15000,
	defendDurationMs: 20000,
	runDurationMs: 5000,
	runCooldownMs: 5000,
	rageDurationMs: 7000,
	rageCooldownMs: 60000,
	actionFocusMs: 3000,
	emoteBurstCount: 4,
	emoteBurstIntervalMs: 300,
	highlightMs: 1000,
};

// Utility to get a duration with sane bounds
export function clampMs(value, min = 300, max = 60000) {
	const v = Number(value);
	if (!Number.isFinite(v)) return min;
	return Math.max(min, Math.min(max, v));
}


